import * as z from "zod";
import { commerceCloudApiKind } from "./get-commerce-cloud-setup";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const verifyCommerceCloudAccess = {
  name: "verifyCommerceCloudAccess" as const,
  input: z.object({
    integrationId: commerceCloudIntegrationId,
    api: commerceCloudApiKind,
  }),
  output: z.object({ ok: z.boolean(), error: z.string().nullish() }),
};
